export default __webpack_public_path__ + "resources/RobotoMono-Regular.df9ebf17f051cd57a3ea1ad6b1f8c9ae.woff2";